import * as React from 'react'
import { Container } from 'components/Layout'
import cn from 'classnames'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import { ContactTriggerFlow } from '../ContactTriggerFlow'
import { IContactClient } from 'features/Contacts/types'

export interface IContactTriggerModalProps {
  contact: IContactClient
  modalCancel: () => undefined
}

export class ContactTriggerFlowModal extends React.Component<IContactTriggerModalProps> {
  render() {
    const { modalCancel, contact } = this.props
    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Subscribe to Flow:</div>
          <ContactTriggerFlow onAfterSubmit={modalCancel} contact={contact} />
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactTriggerFlowModal/ContactTriggerFlowModal.tsx